document.addEventListener('DOMContentLoaded', function () {


    document.querySelectorAll('.variant-quantity .quantity-selector--minus').forEach(function(element) {

        element.off("click keydown");

        const theQuantitySelector = element.closest('quantity-selector');
        const theInput = theQuantitySelector.querySelector('.quantity-selector--input');

        element.on("click keydown", t => {

            if (theInput.value > 0){
                theInput.value = theInput.value - 1;
                window.trigger('theme:product:' + theQuantitySelector.dataset.id + ':quantityChanged');
            }

        })
    })

});

window.newCustomerAccountsEnabled = true;

customElements.whenDefined('shopify-forms-embed').then(() => {
  const observer = new MutationObserver(() => {
    const widget = document.querySelector('shopify-forms-embed');

    if (widget) {
        observer.disconnect();

        const shadowRoot = widget.shadowRoot;
        const sheet = new CSSStyleSheet();

        sheet.replaceSync(`
            #form-container-ref :is(input[type="text"], input[type="email"], input[type="tel"], textarea, button[type="button"]) {
                font-size: 13px;
                letter-spacing: 2px;
            }
            #form-container-ref button[type="submit"] {
                border-radius: 3px;
                font-size: 16px;
                letter-spacing: 1px;
                line-height: 1;
            }
            #form-container-ref form > div:first-child :is(input, textarea) {
                margin-top: 1px;
            }
        `);

        shadowRoot.adoptedStyleSheets.push(sheet);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

/**
 * Global Cart Error Handling Patch
 * Overrides the default addItems method to parse Shopify's JSON error messages.
 */
customElements.whenDefined('cart-element').then(() => {
    const Cart = customElements.get('cart-element');

    // Fully replace the method to avoid double-fetching
    Cart.addItems = async function(options = {}, openDrawer = false) {
        const response = await fetch(`${Shopify.routes.cart_add}.js`, options);

        // 1. Handle Errors
        if (!response.ok) {
            const errorData = await response.json();
            const error = new Error(errorData.message || response.statusText);
            error.code = errorData.status;
            error.description = errorData.description;
            error.response = errorData;

            // window.setTimeout( () => {customElements.get('cart-element').forceRefresh();}, 1000)
            Cart.forceRefresh();

            if (openDrawer) {
                Cart.openDrawer(openDrawer);
            }

            throw error;
        }

        // 2. Handle Success (Replicating original theme.js logic)
        const data = await response.json();
        const { id, items, quantity, sections } = data;

        // Update the internal basket state
        if (items) {
            items.forEach(({ id, quantity }) => Cart.updateBasket(id, quantity));
        } else if (id && quantity) {
            Cart.updateBasket(id, quantity);
        }

        // Trigger UI updates
        if (openDrawer) {
            Cart.openDrawer(openDrawer);
        }

        // Update totals and HTML sections
        const totalItems = Object.values(Cart.basket).reduce((acc, qty) => acc + qty, 0);
        Cart.updateTotals(totalItems);
        Cart.updateAllHtml(sections);

        return data;
    };



     //    Add this version to your `custom.js`. It performs two steps: it syncs the internal data from the JSON API, then it fetches the updated HTML for the drawer.

    Cart.forceRefresh = async function() {
        // 1. Get the latest DATA (items, total count, etc)
        const dataResponse = await fetch(`${Shopify.routes.cart}.js`);
        const cartData = await dataResponse.json();

        // Sync internal state
        Cart.fillBasket(cartData.items);
        Cart.updateTotals(cartData.item_count);

        // 2. Get the latest HTML SECTIONS
        // We fetch from the main /cart page with the sections parameter
        const sectionsResponse = await fetch(`${Shopify.routes.cart}?sections=${Cart.sections}`);
        const sectionsData = await sectionsResponse.json();

        // Refresh the HTML in the drawer/page
        Cart.updateAllHtml(sectionsData);

        return cartData;
    };
});

// Calculate navigation height
const nav = document.querySelector('.header--primary-nav');

if (nav) {
    const updateNav = () => {
        document.documentElement.style.setProperty('--nav--height', `${nav.offsetHeight}px`);
    };

    updateNav();
    new ResizeObserver(updateNav).observe(nav);
}

// Link the header search with the quick search drawer
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-search-input]').forEach((input) => {
        const form = input.closest('form');

        // Return if no form
        if (!form) return;

        // Wait for the quick search input to be rendered after the drawer opens
        const waitForDrawerInput = (timeout = 2000) =>
            new Promise(resolve => {
                const end = performance.now() + timeout;

                // Poll once per animation frame until the drawer input exists
                const check = () => {
                    const input = document.querySelector('[data-drawer-view="search"] #search_input');

                    if (input || performance.now() > end) {
                        resolve(input);
                    } else {
                        requestAnimationFrame(check);
                    }
                };

                check();
            });

        // Return the quick search input, opening the search drawer if needed
        const openDrawer = async () => {
            const target = document.querySelector('[data-drawer-view="search"] #search_input');

            if (target) return target;

            if (window.scrollY > 0) {
                window.scrollTo(0, 0);
            }

            window.trigger('theme:drawer:open', {
                side: 'top',
                view: 'search',
                trigger: input,
            });

            return waitForDrawerInput();
        };

        // Open the quick search drawer when the header search receives focus
        ['focus', 'click'].forEach(event =>
            input.addEventListener(event, openDrawer)
        );

        // Mirror every keystroke from the header search into the quick search
        input.addEventListener('input', async () => {
            const target = await openDrawer();

            if (!target) return;

            target.value = input.value;

            target.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        });

        // Close the drawer when focus leaves the header search if no search term has been entered
        form.addEventListener('focusout', () => {
            requestAnimationFrame(() => {
                const active = document.activeElement;

                if (form.contains(active)) return;

                const drawer = document.querySelector('[data-drawer-view="search"] .drawer--root');

                if (drawer?.contains(active)) return;

                if (input.value.trim() !== '') return;

                window.trigger('theme:drawer:close');
            });
        });

        // Navigate to the full search results page when the header search form is submitted
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const query = input.value.trim();

            if (!query) return;

            window.location.href = `/search?type=product&q=${encodeURIComponent(query)}*`;
        });
    });
});

// Create a new ElementRelocator class to support media queries
customElements.whenDefined('element-relocator').then(() => {
    const ElementRelocator = customElements.get('element-relocator');

    class ResponsiveElementRelocator extends ElementRelocator {
        connectedCallback() {
            const selector = this.getAttribute("data-move-into");
            this.element_to_move_into = document.querySelector(selector);
            this.element_to_move = this.firstElementChild;

            if (!this.element_to_move_into || !this.element_to_move) return;
            
            this.mediaQuery = this.getMediaQuery();
            this.update = this.update.bind(this);
            this.update();

            if (this.mediaQuery) {
                this.mediaQuery.addEventListener("change", this.update);
            }
        }

        disconnectedCallback() {
            if (this.mediaQuery) {
                this.mediaQuery.removeEventListener("change", this.update);
            }

            super.disconnectedCallback();
        }

        getMediaQuery() {
            switch (this.dataset.moveMq) {
                case "small":
                    return window.matchMedia("(max-width: 767px)");
                case "medium-large":
                    return window.matchMedia("(min-width: 768px)");
                default:
                    return null;
            }
        }

        update() {
            const shouldMove = !this.mediaQuery || this.mediaQuery.matches;

            requestAnimationFrame(() => {
                if (shouldMove) {
                    this.element_to_move_into.replaceChildren(this.element_to_move);
                } else if (this.firstElementChild !== this.element_to_move) {
                    this.appendChild(this.element_to_move);
                }
            });
        }
    }
    
    customElements.define("element-relocator-responsive", ResponsiveElementRelocator);
});

// Map the new sort dropdown to the existing radio buttons
document.addEventListener('DOMContentLoaded', () => {
    const select = document.getElementById('sort-select');

    if (!select) return;

    const radios = document.querySelectorAll('.filter--form input[name="sort_by"]');

    const syncSelect = () => {
        const checked = [...radios].find(r => r.checked);
        select.value = checked ? checked.value : 'relevance';
    };

    select.addEventListener('change', () => {
        const radio = [...radios].find(r => r.value === select.value);

        if (radio) {
            radio.nextElementSibling.click();
        }
    });

    document.addEventListener('click', e => {
        if (
            e.target.closest('.navigation--active-clear') ||
            e.target.closest('.navigation--active-tag[data-type="sort"]')
        ) {
            requestAnimationFrame(syncSelect);
        }
    });
});